import { Component } from "react";

//library imports
import Modal from '@mui/material/Modal';
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';

//components
import HeaderCommon from '../components/HeaderCommon'
import MapComponent from "../components/MapComponent";
import SpinnerLoader from '../components/SpinnerLoader'
import CartComponent from "../components/CartComponent";
//api
import { getOrderSummary, getCountries, postLocalItems, recieveToken, addNewAddress, placeOrder, existingUser, addNonExistingUser, getSupportData, getCompanyInfo, sendWhatsapp, createRazorPayOrder, getOrderWithOrderId } from "../services/services";

//constants
import * as language from '../constants/languages'

//icons
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import Ionicon from '../assets/svg/caret-down-outline.svg'
import Closeicon from '../assets/svg/x-circle.svg'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MapIcon from "../assets/svg/mapIcon.svg"
import TabCategory from '../assets/svg/bottom tab bar/tabcategory.svg'
import VerifiedIcon from '../assets/svg/verified.svg'
//styles
import '../styles/ShareCatalogue.css'
import OrderSucess from "../components/OrderSuccess";

const DEFAULT_COUNTRIES = [
    { countryId: 1, countryName: "India", countryCode: "IN", countryPhoneCode: "+91", countryFlag: "https://flagcdn.com/w40/in.png", active: true },
    { countryId: 2, countryName: "United Arab Emirates", countryCode: "AE", countryPhoneCode: "+971", countryFlag: "https://flagcdn.com/w40/ae.png", active: true },
    { countryId: 3, countryName: "Saudi Arabia", countryCode: "SA", countryPhoneCode: "+966", countryFlag: "https://flagcdn.com/w40/sa.png", active: true },
    { countryId: 4, countryName: "Qatar", countryCode: "QA", countryPhoneCode: "+974", countryFlag: "https://flagcdn.com/w40/qa.png", active: true },
    { countryId: 5, countryName: "Oman", countryCode: "OM", countryPhoneCode: "+968", countryFlag: "https://flagcdn.com/w40/om.png", active: true },
    { countryId: 6, countryName: "Kuwait", countryCode: "KW", countryPhoneCode: "+965", countryFlag: "https://flagcdn.com/w40/kw.png", active: true },
    { countryId: 7, countryName: "Bahrain", countryCode: "BH", countryPhoneCode: "+973", countryFlag: "https://flagcdn.com/w40/bh.png", active: true },
    { countryId: 8, countryName: "Singapore", countryCode: "SG", countryPhoneCode: "+65", countryFlag: "https://flagcdn.com/w40/sg.png", active: true },
    { countryId: 9, countryName: "Malaysia", countryCode: "MY", countryPhoneCode: "+60", countryFlag: "https://flagcdn.com/w40/my.png", active: true },
    { countryId: 10, countryName: "United Kingdom", countryCode: "GB", countryPhoneCode: "+44", countryFlag: "https://flagcdn.com/w40/gb.png", active: true },
    { countryId: 11, countryName: "United States", countryCode: "US", countryPhoneCode: "+1", countryFlag: "https://flagcdn.com/w40/us.png", active: true },
    { countryId: 12, countryName: "Canada", countryCode: "CA", countryPhoneCode: "+1", countryFlag: "https://flagcdn.com/w40/ca.png", active: true },
    { countryId: 13, countryName: "Australia", countryCode: "AU", countryPhoneCode: "+61", countryFlag: "https://flagcdn.com/w40/au.png", active: true },
];

class ShareCataloguePage extends Component {
    constructor(props) {
        super(props)
        this.mediaQueryList = window.matchMedia("(min-width: 992px)");
        this.state = {
            currencySymbol: "",
            whatsAppNo: "",
            address: null,
            comments: '',
            countriesList: DEFAULT_COUNTRIES,
            currentLongitude: null,
            currentLatitude: null,
            isLoading: false,
            landmark: '',
            locationModal: false,
            name: '',
            number: '',
            openCountryPicker: false,
            countrySearch: '',
            userCountry: null,
            noaddressid: false,
            selectedCountry: DEFAULT_COUNTRIES[0],
            countryFlag: DEFAULT_COUNTRIES[0].countryFlag,
            message: '',
            snackopen: false,
            priceDetails: {},
            orderPlacedModal: false,
            whatsApptoken: '',
            whatsInstanceid: '',
            isLargeDisplay: this.mediaQueryList.matches,
            encryptedQr: undefined,
            isPending: false,
            isCartComponentVisible: false,
            invalidItems: [],
            cartBaseTotal: 0,
            cartTotalWithGst: 0,
            cartItemCount: 0
        };
        this.checkDevice = this.checkDevice.bind(this)
        this.orderPlacedData = undefined
        this.sortCartItems();
        this.sortedCartItems = []
        this.checkInterval = undefined
        this.token = undefined
    }

    async getCompanyInfo() {
        await getCompanyInfo(language.companyidValue).then((response) => {
            // console.log(response, 'companyInfo');
            if (response.status === 'success') {
                this.setState({
                    currencySymbol: response.data.currencySymbol
                })
            }
        }).catch((error) => {
            // console.log(error, 'company info error');
        })
    }

    // get the location details
    async getLocation() {
        try {
            if (navigator.permissions && navigator.permissions.query) {
                navigator.permissions.query({ name: "geolocation" }).catch(() => {});
            }
        } catch (e) {}

        if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const currentLongitude = position.coords.longitude;
                    const currentLatitude = position.coords.latitude;
                    this.setState({
                        currentLongitude: currentLongitude,
                        currentLatitude: currentLatitude,
                        locationModal: false,
                    });
                },
                (error) => {
                    // Location optional on initial load, ignore error
                },
                { enableHighAccuracy: false, timeout: 5000, maximumAge: 60000 }
            );
        }
    }

    async sortCartItems() {
        const getCart = localStorage.getItem('cartItems');
        const cart = JSON.parse(getCart);
        let total = 0;
        let itemCount = 0;
        if (cart?.customerCartItems) {
            for (let i = 0; i < cart.customerCartItems.length; i++) {
                const item = cart.customerCartItems[i];
                this.sortedCartItems[i] = `\n${i + 1}. \*${item?.product?.productName}\*   *   ${item?.qty} ${item?.product?.unit == '-- None --' ? "" : item?.product?.unit}`;
                const qty = Number(item?.qty || 1);
                itemCount += qty;
                const price = item?.product?.oRate != null && item.product.oRate > 0
                    ? Number(item.product.oRate)
                    : Number(item?.product?.sRate || 0);
                const inc = Number(item?.product?.incrementValue || 1);
                total += qty * price * inc;
            }
        }
        this.setState({
            cartBaseTotal: total,
            cartTotalWithGst: Math.round(total * 1.18 * 100) / 100,
            cartItemCount: itemCount
        });
    }

    async getSupportInfoData() {
        await getSupportData(language.companyidValue).then((supportData) => {
            if (supportData.status === 'success') {
                this.setState({
                    supportNumber: (supportData.data.contactNos),
                    whatsAppNo: (supportData.data.whatsApp)
                })
            }
        })
    }

    //get countries list
    async getCountryData() {
        try {
            const countryResponse = await getCountries(language.companyidValue);
            if (countryResponse && countryResponse.status === "success" && Array.isArray(countryResponse.data) && countryResponse.data.length > 0) {
                this.setState({
                    countriesList: countryResponse.data
                });
                if (this.state.userCountry == null && countryResponse.data.length === 1) {
                    this.setState({
                        selectedCountry: countryResponse.data[0]
                    });
                } else {
                    const country = countryResponse.data.find(data => data.countryCode === this.state.userCountry);
                    if (country) {
                        this.setState({
                            selectedCountry: country
                        });
                    } else {
                        this.setState({
                            selectedCountry: countryResponse.data[0]
                        });
                    }
                }
            } else {
                this.setState({
                    countriesList: DEFAULT_COUNTRIES,
                    selectedCountry: (this.state.selectedCountry && this.state.selectedCountry.countryPhoneCode) ? this.state.selectedCountry : DEFAULT_COUNTRIES[0]
                });
            }
        } catch (error) {
            this.setState({
                countriesList: DEFAULT_COUNTRIES,
                selectedCountry: (this.state.selectedCountry && this.state.selectedCountry.countryPhoneCode) ? this.state.selectedCountry : DEFAULT_COUNTRIES[0]
            });
        } finally {
            this.setState({
                isLoading: false
            });
        }
    }

    //function for country picker list
    renerderCounties(countryData, i) {
        const details = countryData;
        const isSelected = this.state.selectedCountry?.countryId === details.countryId ||
            this.state.selectedCountry?.countryPhoneCode === details.countryPhoneCode;

        return (
            <div
                key={details.countryId || i}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '10px 14px',
                    borderRadius: 8,
                    marginBottom: 6,
                    cursor: 'pointer',
                    border: isSelected ? '1.5px solid #1164af' : '1px solid #f0f0f0',
                    backgroundColor: isSelected ? 'rgba(17, 100, 175, 0.08)' : '#ffffff',
                    transition: 'all 0.15s ease'
                }}
                onClick={() => {
                    this.setState({
                        selectedCountry: details,
                        openCountryPicker: false,
                        countrySearch: ''
                    });
                }}
            >
                <div style={{ marginRight: 14, display: 'flex', alignItems: 'center' }}>
                    <img
                        src={details.countryFlag}
                        alt={details.countryName}
                        style={{ width: 28, height: 19, objectFit: 'cover', borderRadius: 3, border: '1px solid #e0e0e0' }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <p style={{ fontSize: 14, margin: 0, fontFamily: 'Poppins-Regular', color: '#333' }}>
                        <strong style={{ color: '#1164af', marginRight: 6 }}>{details.countryPhoneCode}</strong>
                        {details.countryName}
                    </p>
                </div>
                {isSelected && (
                    <div style={{ color: '#1164af', fontWeight: 'bold', fontSize: 15 }}>✓</div>
                )}
            </div>
        );
    }


    // get the location
    async selectLocation() {
        navigator.permissions.query({ name: "geolocation" }).then((result) => {
            if (result.state === "denied") {
                this.setState({
                    message: 'Please enable location',
                    snackopen: true,
                    locationModal: false
                })
                return
            }
        })
        await navigator.geolocation.getCurrentPosition(
            (position) => {
                const currentLongitude = position.coords.longitude;
                const currentLatitude = position.coords.latitude;
                this.setState({
                    currentLongitude: (currentLongitude),
                    currentLatitude: (currentLatitude),
                    locationModal: !this.state.locationModal,
                })
            },
            (error) => {
                // console.log(error, 'Error in getting location')
                this.setState({
                    message: 'Error in getting location',
                    snackopen: true,
                    locationModal: false
                })
            },
            { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 }
        )
    }

    // get cart count
    getCartCount = () => {
        const cart = localStorage.getItem('cartItems');
        if (!cart) {
            return true
        }
    }

    shareCatalogue = async () => {
        // let setArray = [['name', this.state.name ? this.state.name : ''], ['address', this.state.address ? String(this.state.address) : ''], ['number', this.state.number ? this.state.number : ''], ['comments', this.state.comments ? this.state.comments : ''], ['landmark', this.state.landmark ? this.state.landmark : '']]
        localStorage.setItem('name', this.state.name ? this.state.name : '')
        localStorage.setItem('address', this.state.address ? String(this.state.address) : '')
        localStorage.setItem('number', this.state.number ? this.state.number : '')
        localStorage.setItem('comments', this.state.comments ? this.state.comments : '')
        localStorage.setItem('landmark', this.state.landmark ? this.state.landmark : '')
        if (this.getCartCount()) {
            this.setState({
                message: 'Your cart is empty',
                snackopen: true
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return
        }
        if (this.state.number == null || this.state.number == undefined) {
            this.setState({
                message: 'Please enter a valid mobile number',
                snackopen: true
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return
        }
        else if (/^[0-9]*$/.test(this.state.number) == false) {
            this.setState({
                message: 'Please enter a valid mobile number',
                snackopen: true
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return
        }
        else if (this.state.name == null || this.state.name == undefined) {
            this.setState({
                message: 'Please enter your name',
                snackopen: true
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return
        }
        else if (this.state.name.trim() == '') {
            this.setState({
                message: 'Please enter your name',
                snackopen: true
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return
        }
        // else if (this.state.address == null || this.state.address == undefined) {
        //     this.setState({
        //         message: 'Please enter your address',
        //         snackopen: true
        //     })
        //     const event = new CustomEvent('catalogueShare');
        //     window.dispatchEvent(event)
        //     return
        // }
        // else if (String(this.state.address).trim().length == 0) {
        //     this.setState({
        //         message: 'Please enter your address',
        //         snackopen: true
        //     })
        //     const event = new CustomEvent('catalogueShare');
        //     window.dispatchEvent(event)
        //     return
        // }
        // else if (this.state.landmark == null || this.state.landmark == undefined) {
        //     this.setState({
        //         message: 'Please enter a Landmark',
        //         snackopen: true
        //     })
        //     const event = new CustomEvent('catalogueShare');
        //     window.dispatchEvent(event)
        //     return
        // }
        // else if (this.state.landmark.trim().length == 0) {
        //     this.setState({
        //         message: 'Please enter a Landmark',
        //         snackopen: true
        //     })
        //     const event = new CustomEvent('catalogueShare');
        //     window.dispatchEvent(event)
        //     return
        // }
        else {
            this.setState({
                isLoading: (true)
            })
            this.ExistingUserCheck()
        }
    }

    async ExistingUserCheck() {
        if (this.state.selectedCountry?.countryId == null) {
            this.setState({
                message: language.countryChooseLabel,
                snackopen: true,
                isLoading: false
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return
        }

        const mobileNo = this.state.selectedCountry.countryPhoneCode + this.state.number;
        // console.log(mobileNo)
        await existingUser(mobileNo).then((existingUserResponse) => {
            if (existingUserResponse.status == "success") {
                this.setState({
                    userData: (existingUserResponse)
                })
                setTimeout(() => {
                    this.recieveToken(mobileNo)
                }, 500)
            }
            else if (existingUserResponse.status == "failed") {
                this.addNonExistingUser(mobileNo)
            }
        }).catch(() => {
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            this.setState({
                message: 'Something went wrong, please try again...',
                snackopen: true,
                isLoading: false
            })
            //this.props.navigation(-1)
        })
    }

    async addNonExistingUser(mobileNo) {
        await addNonExistingUser(language.companyidValue,
            this.state.name,
            mobileNo,
            '',
            this.state.number,
            '').then((registerData) => {
                if (registerData.status == "success") {
                    this.setState({
                        userData: (registerData)

                    })

                    setTimeout(() => {

                        this.recieveToken(mobileNo)
                    }, 500)

                }
                else if (registerData.status == "failed" && registerData.message == "Mobile Number Already Registered") {
                    this.setState({
                        userData: (registerData),
                        noaddressid: true
                    })

                    setTimeout(() => {

                        this.recieveToken(mobileNo)
                    }, 500)
                }
                else {
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                    this.setState({
                        message: 'An error occured, Please try again later...',
                        snackopen: true,
                        isLoading: false
                    })
                    //this.props.navigation(-1)
                }

            }).catch(() => {
                const event = new CustomEvent('catalogueShare');
                window.dispatchEvent(event)
                this.setState({
                    message: 'An error occured, Please try again later...',
                    snackopen: true,
                    isLoading: false
                })
                //this.props.navigation(-1)
            })
    }

    // login user
    async recieveToken(mobile) {
        // console.log(mobile)
        if (this.state.selectedCountry?.countryId == null) {
            this.setState({
                message: language.countryChooseLabel,
                snackopen: true
            })
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            return;
        }
        await recieveToken(language.companyidValue,
            mobile,
            this.state.number).then((loginData) => {
                if (loginData.error) {
                    this.setState({
                        isLoading: (false),
                        massage: loginData.error,
                        snackopen: true
                    })
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                    return
                }
                else {
                    this.token = loginData.access_token
                    this.postLocalItems(loginData.access_token);
                }
            })
            .catch((error) => {
                const event = new CustomEvent('catalogueShare');
                window.dispatchEvent(event)
                this.setState({
                    message: 'An error occured, Please try again later...',
                    snackopen: true,
                    isLoading: false
                })
                //this.props.navigation(-1)
            })
    }

    async addressDataSubmit(token, localpostdata) {
        // await getAddressInfo(language.companyidValue, token).then((address)=>{
        //     console.log(address)
        // })
        this.AddAddress(token, localpostdata)
    }

    async AddAddress(token, localpostdata) {
        // console.log(localpostdata)
        try {
            var mobileNo = this.state.selectedCountry.countryPhoneCode + this.state.number;
            let data = {
                CustomerId: this.state.noaddressid ? localpostdata.customerId : this.state.userData.data.customerId,
                CustomerAddressId: this.state.noaddressid ? localpostdata.deliveryAddressId : this.state.userData.data.customerAddressId,
                Name: this.state.name,
                MobileNo1: mobileNo,
                HouseNo: this.state.address,
                Area: '',
                City: this.state.city,
                State: '',
                Country: '',
                Pincode: '',
                Landmark: this.state.landmark,
                Default: true,
                Latitude: this.state.currentLatitude,
                Longitude: this.state.currentLongitude,
                type: 1
            }
            await addNewAddress(language.companyidValue, data, token).then((editAddress) => {
                this.getOrderSummary(token)
            }).catch((e) => {
                const event = new CustomEvent('catalogueShare');
                window.dispatchEvent(event)
                // console.log(e)
                this.setState({
                    message: 'An error occured, Please try again later...',
                    snackopen: true,
                    isLoading: false
                })
                //this.props.navigation(-1)
            })
        } catch (e) {
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            this.setState({
                message: 'An error occured, Please try again later...',
                snackopen: true,
                isLoading: false
            })
            //this.props.navigation(-1)
        }
    }

    checkForInactiveProducts(inactiveProduct, cart) {
        // console.log(inactiveProduct, cart)
        const inactiveProductIds = inactiveProduct;
        const inactiveItems = cart.filter(item => inactiveProductIds.includes(item.product.productId));

        // console.log(inactiveItems, "invalid")
        this.setState({
            invalidItems: inactiveItems,
            isCartComponentVisible: true
        })
    }

    async getOrderSummary(token) {

        // debugger
        const branchId = localStorage.getItem('storeId');
        const cart = localStorage.getItem('cartItems');
        const cartItems = JSON.parse(cart);
        if (cartItems != null) {
            var localItems = [];
            for (let i of cartItems.customerCartItems) {
                localItems = [...localItems,
                {
                    ProductId: i.product.productId,
                    QtyOut: i.qty,
                    SRate: i.product.sRate,
                    PRate: i.product.pRate,
                    isTrackStock: i.product.isTrackStock
                }
                ]
            }

            let discountAmount
            await getOrderSummary(language.companyidValue, branchId, token, localItems).then((orderSummary) => {
                if (orderSummary.status == "success") {
                    this.setState({
                        productItems: orderSummary.data.orderItems,
                        deliveyAddress: orderSummary.data.orderAddresses[0],
                        priceDetails: orderSummary.data
                    })
                    // let taxAmount = this.state.priceDetails.netTaxAmount;
                    if (this.state.priceDetails.billDiscount != null) {
                        discountAmount = this.state.priceDetails.discountAmount;
                    } else {
                        discountAmount = this.state.priceDetails.discountAmount +
                            this.state.priceDetails.billDiscount;
                    }
                    let keys = ['discountType', 'discountRefId'];
                    let filtered = orderSummary.data.orderDiscounts.filter(
                        (s => o =>
                            (k => !s.has(k) && s.add(k))
                                (keys.map(k => o[k]).join('|'))
                        )
                            (new Set)
                    );
                    let stockNotAvailabeleCount = orderSummary.data.orderItems.filter(item => item.isStockAvailable == false).length;

                    let stockNotAvailable = (stockNotAvailabeleCount > 0 ? true : false)
                    let filteredOffers = filtered

                    // this.props.navigation(`/PaymentsPage/${orderSummary.data.orderId}/${orderSummary.data.totalAmount}/${this.state.name}/${this.state.number}/${token}/${branchId}`)
                    // this.payWithRazorPay(orderSummary.data, token)
                    //     const msg = encodeURIComponent(`\*Your Order Recieved\*  \n\n\*Order No:\* ${this.orderPlacedData?.orderNo ? this.orderPlacedData?.orderNo : ''} \n\n \*Product Details:\* \n${this.sortedCartItems.join('\n')}\n\n\*Total:\*   ${this.state.priceDetails ? this.state.currencySymbol : ''} ${this.state.priceDetails ? this.state.priceDetails.totalAmount : ''}\n\n\*Customer Details:\*\n\n${this.state.name ? this.state.name : ''}\n${this.state.address == '' ? this.state.automaticAddress : this.state.address}\n\n\*Contact Number:\* ${this.state.number ? this.state.number : ''}\n\n\*Land Mark\*: ${this.state.landmark ? this.state.landmark : ''}\n\n\*Comments:\* ${this.state.comments ? this.state.comments : ''} \n\nFor any queries please contact: ${this.state.supportNumber}\n\n\*Location:\* https://maps.google.com/?q=${this.state.currentLatitude},${this.state.currentLongitude}`)
                    // window.open(`whatsapp://send?text=${msg}&phone=${this.state.whatsAppNo}`)
                    this.paymentSuccess({
                        razorpay_payment_id: "",
                        razorpay_order_id: "",
                    }, orderSummary.data)

                }
                else if (orderSummary.message === "Out of Stock") {
                    this.checkForInactiveProducts(orderSummary.data, cartItems.customerCartItems)
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                }
                else {
                    this.setState({
                        isLoading: (false)

                    })

                }
            })
                .catch((error) => {
                    // console.log(error)
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                    this.setState({
                        message: 'Something went wrong, please try again',
                        snackopen: true,
                        isLoading: false
                    })
                    //this.props.navigation(-1)
                })
        }
        else {
            const event = new CustomEvent('catalogueShare');
            window.dispatchEvent(event)
            this.setState({
                message: 'Something went wrong, please try again',
                snackopen: true,
                isLoading: false
            })
        }
    }

    paymentSuccess = async (successData, summaryData) => {
        const priceDetails = summaryData || this.state.priceDetails || {};
        const baseAmount = summaryData?.totalAmount != null
            ? Number(summaryData.totalAmount)
            : (this.state.priceDetails?.totalAmount != null
                ? Number(this.state.priceDetails.totalAmount)
                : Number(summaryData?.netAmount || priceDetails?.netAmount || this.state.cartBaseTotal || 0));
        const totalAmountWithGst = Math.round(baseAmount * 1.18 * 100) / 100;

        const order = {
            OrderPaymentId: successData?.razorpay_payment_id || "",
            PaymentRef: successData?.razorpay_order_id || "",
            PaymentMessage: null,
            providers: [],
            OrderId: priceDetails.orderId,
            PaymentAmount: totalAmountWithGst,
            Status: priceDetails.status || "PENDING",
            PaymentProviderType: 'MANUAL',
            PaymentProviderName: null,
            PaymentMethod: null,
            PaymentProviderId: null,
            PaymentDate: new Date().toISOString(),
            OrderChanel: 'App',
            TimeSlotId: 0,
        }
        this.orderPlacement(order, 3, 2000);
    }

    async orderPlacement(order, retries, delay) {
        let branchId = localStorage.getItem('storeId');
        await placeOrder(language.companyidValue, order, branchId, this.token).then((placeOrder) => {
            if (placeOrder.status == 'success') {
                this.setState({
                    isLoading: (false),
                    message: placeOrder.message,
                    snackopen: true,
                    orderPlacedModal: true
                })
                const event = new CustomEvent('catalogueShare');
                const productEvent = new CustomEvent('productQtyChange');
                this.getOrderStatus()
                // const msg = encodeURIComponent(`\*Your Order Recieved\*  \n\n\*Order No:\* ${this.orderPlacedData?.orderNo ? this.orderPlacedData?.orderNo : ''} \n\n \*Product Details:\* \n${this.sortedCartItems.join('\n')}\n\n\*Total:\*   ${this.state.priceDetails ? this.state.currencySymbol : ''} ${this.state.priceDetails ? this.state.priceDetails.totalAmount : ''}\n\n\*Customer Details:\*\n\n${this.state.name ? this.state.name : ''}\n${this.state.address == '' ? this.state.automaticAddress : this.state.address}\n\n\*Contact Number:\* ${this.state.number ? this.state.number : ''}\n\n\*Land Mark\*: ${this.state.landmark ? this.state.landmark : ''}\n\n\*Comments:\* ${this.state.comments ? this.state.comments : ''} \n\nFor any queries please contact: ${this.state.supportNumber}\n\n\*Location:\* https://maps.google.com/?q=${this.state.currentLatitude},${this.state.currentLongitude}`)
                // window.open(`whatsapp://send?text=${msg}&phone=${this.state.whatsAppNo}`)
                // this.sendOrderToWhatsapp(msg)
                localStorage.removeItem('cartItems')
                window.dispatchEvent(event)
                window.dispatchEvent(productEvent)
            } else {
                throw new Error
                //this.props.navigation(-1)
            }
        })
            .catch((error) => {
                if (retries > 0) {
                    // console.log(`Retrying... (${retries} retries left)`);
                    // Retry the `placeOrder` function after a delay
                    setTimeout(() => {
                        this.orderPlacement(order, retries - 1, delay * 2); // Exponentially increase the delay
                    }, delay);
                } else {
                    this.setState({
                        isPending: true
                    })
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event);
                    this.setState({
                        message: 'Something went wrong, please try again',
                        snackopen: true,
                        isLoading: false
                    })
                    // // After all retries fail, show error message
                    // setOrderFailedModal(true);
                    // Toast.show('Failed to place the order after multiple attempts. Please try again later.', { duration: Toast.durations.LONG });
                    // EventRegister.emit('enableBtn');
                }
                // Toast.show('An error occurred')
                // EventRegister.emit('enableBtn')
                // navigation.goBack()
            })
    }
    async getOrderStatus() {

        try {
            const orderStatusResponse = await getOrderWithOrderId(language.companyidValue, this.state.priceDetails.orderId)
            if (orderStatusResponse.status === "success" && orderStatusResponse.data[0].status === 'ORDERED') {
                clearInterval(this.checkInterval)
                this.orderPlacedData = orderStatusResponse.data[0]
                this.setState({
                    isLoading: false,
                    encryptedQr: orderStatusResponse.message,
                    isPending: false,
                    orderPlacedModal: true,
                    orderFailedModal: false
                })
                const event = new CustomEvent('catalogueShare');
                const productEvent = new CustomEvent('productQtyChange');
                window.dispatchEvent(event)
                window.dispatchEvent(productEvent)
                // const msg = encodeURIComponent(`\*Your Order Recieved\*  \n\n\*Order No:\* ${this.orderPlacedData?.orderNo ? this.orderPlacedData?.orderNo : ''} \n\n \*Product Details:\* \n${this.sortedCartItems.join('\n')}\n\n\*Total:\*   ${this.state.priceDetails ? this.state.currencySymbol : ''} ${this.state.priceDetails ? this.state.priceDetails.totalAmount : ''}\n\n\*Customer Details:\*\n\n${this.state.name ? this.state.name : ''}\n${this.state.address == '' ? this.state.automaticAddress : this.state.address}\n\n\*Contact Number:\* ${this.state.number ? this.state.number : ''}\n\n\*Land Mark\*: ${this.state.landmark ? this.state.landmark : ''}\n\n\*Comments:\* ${this.state.comments ? this.state.comments : ''} \n\nFor any queries please contact: ${this.state.supportNumber}\n\n\*Location:\* https://maps.google.com/?q=${this.state.currentLatitude},${this.state.currentLongitude}`)
                // window.open(`whatsapp://send?text=${msg}&phone=${this.state.whatsAppNo}`)
            }
        } catch (error) {

        }
    }

    //initialize razorpay
    async payWithRazorPay(orderSummaryData, token) {
        try {
            const baseAmount = Number(orderSummaryData?.totalAmount || this.state.cartBaseTotal || 0);
            const totalWithGst = Math.round(baseAmount * 1.18 * 100) / 100;
            const amountInPaise = Math.round(totalWithGst * 100);
            const createOrderResponse = await createRazorPayOrder(orderSummaryData.orderId, amountInPaise, token)
            if (createOrderResponse.status === "success" && amountInPaise === createOrderResponse.data.amount) {
                var options = {
                    "key": "rzp_live_b5Ha12UXRBaWx1", // Enter the Key ID generated from the Dashboard
                    "amount": String(createOrderResponse.data.amount), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                    "currency": "INR",
                    "name": 'Naipunnya Institute of Management and Information Technology', //your business name
                    "order_id": createOrderResponse.data.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                    "handler": (res) => this.paymentSuccess(res, orderSummaryData),
                    "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                        "name": this.state.name, //your customer's name
                        "email": "gaurav.kumar@example.com",
                        "contact": this.state.number  //Provide the customer's phone number for better conversion rates 
                    },
                    "modal": {
                        "ondismiss": () => {
                            // Handle the modal dismissal (cancellation)
                            this.setState({
                                message: 'Payment was cancelled. Please try again if you wish to complete the transaction.',
                                snackopen: true,
                                isLoading: false
                            });
                        }
                    }
                };
                var rzp1 = new window.Razorpay(options);
                rzp1.on('payment.failed', function (response) {
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                    this.setState({
                        message: 'Your payment failed',
                        snackopen: true,
                        isLoading: false
                    })
                });
                rzp1.on('payment.cancelled', function (response) {
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                    this.setState({
                        message: 'Your payment was failed',
                        snackopen: true,
                        isLoading: false
                    })
                });
                rzp1.open();
            }
            else {
                const event = new CustomEvent('catalogueShare');
                window.dispatchEvent(event)
                this.setState({
                    message: 'Something went wrong, please try again',
                    snackopen: true,
                    isLoading: false
                })
            }
        } catch (error) {

        }
    }

    async sortCartItems() {
        const getCart = localStorage.getItem('cartItems');
        const cart = JSON.parse(getCart);
        let total = 0;
        let itemCount = 0;
        if (cart?.customerCartItems) {
            for (let i = 0; i < cart.customerCartItems.length; i++) {
                const item = cart.customerCartItems[i];
                this.sortedCartItems[i] = `\n${i + 1}. \*${item?.product?.productName}\*   x   ${item?.qty} ${item?.product?.unit == '-- None --' ? "" : item?.product?.unit}`;
                const qty = Number(item?.qty || 1);
                itemCount += qty;
                const price = item?.product?.oRate != null && item.product.oRate > 0
                    ? Number(item.product.oRate)
                    : Number(item?.product?.sRate || 0);
                const inc = Number(item?.product?.incrementValue || 1);
                total += qty * price * inc;
            }
        }
        this.setState({
            cartBaseTotal: total,
            cartTotalWithGst: Math.round(total * 1.18 * 100) / 100,
            cartItemCount: itemCount
        });
    }

    // post the local items
    async postLocalItems(token) {
        let branchId = localStorage.getItem('storeId');
        let cart = localStorage.getItem('cartItems');
        let cartItems = JSON.parse(cart);
        if (cartItems != null) {
            var localItems = [];
            for (let i of cartItems.customerCartItems) {
                localItems = [...localItems,
                {
                    productId: i.product.productId,
                    variantId: i.variantId,
                    qty: i.qty
                }
                ]
            }
            await postLocalItems(language.companyidValue, branchId, localItems, token).then((localPost) => {
                if (localPost.status == "success") {
                    this.addressDataSubmit(
                        token, localPost.data
                    )
                }
                else if (localPost.message === "Inactive Products" || localPost.message === "Out of Stock") {
                    this.checkForInactiveProducts(localPost.data, cartItems.customerCartItems)
                }
                else {
                    const event = new CustomEvent('catalogueShare');
                    window.dispatchEvent(event)
                    this.setState({
                        message: 'Something went wrong, please try again',
                        snackopen: true,
                        isLoading: false
                    })
                    //this.props.navigation(-1)
                }

            }).catch((error) => {
                const event = new CustomEvent('catalogueShare');
                window.dispatchEvent(event)
                this.setState({
                    message: 'Something went wrong, please try again',
                    snackopen: true,
                    isLoading: false
                })
                //this.props.navigation(-1)
            })
        }
    }

    async getSupportInfoData() {
        await getSupportData(language.companyidValue).then((supportData) => {
            if (supportData.status === 'success') {
                this.setState({
                    supportNumber: (supportData.data.contactNos),
                    whatsAppNo: (supportData.data.catalogueShareMobile),
                    whatsApptoken: supportData.data.whatsAppAccessToken,
                    whatsInstanceid: supportData.data.whatsAppInstanceID
                })
                // console.log(supportData)
            }
        })
    }

    //getdetsils from storage
    async getDetails() {
        let getArray = ['name', 'address', 'number', 'comments', 'landmark']
        const result = getArray.map((key) => localStorage.getItem(key))
        this.setState({
            name: (result[0]),
            address: (result[1]),
            number: (result[2]),
            comments: (result[3]),
            landmark: (result[4]),
            isLoading: false
        })

    }
    checkDevice(mql) {
        this.setState({
            isLargeDisplay: mql.matches,
        })
    }
    componentDidMount() {
        if (this.mediaQueryList.addEventListener) {
            this.mediaQueryList.addEventListener("change", this.checkDevice)
        }
        else {
            this.mediaQueryList.addListener(this.checkDevice)
        }
        window.addEventListener('sharecatalogue', this.shareCatalogue)
        this.getDetails()
        this.getLocation()
        this.getSupportInfoData()
        this.getCompanyInfo()
        this.getCountryData()
        this.sortCartItems()

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isPending && !prevState.isPending) {
            this.checkInterval = setInterval(() => {
                this.getOrderStatus();
            }, 5000);
            setTimeout(() => {
                clearInterval(this.checkInterval)
            }, 120000);
        }
        if (!this.state.isPending && prevState.isPending) {
            // Clear interval if isPending becomes false
            clearInterval(this.checkInterval);
            this.checkInterval = null;
        }
    }

    componentWillUnmount() {
        clearInterval(this.checkInterval);
        window.removeEventListener('sharecatalogue', this.shareCatalogue)
        if (this.mediaQueryList.addEventListener) {
            this.mediaQueryList.removeEventListener("change", this.checkDevice)
        }
        else {
            this.mediaQueryList.removeListener(this.checkDevice)
        }
    }

    async existingUserdata() {
        var mobileNo = this.state.selectedCountry.countryPhoneCode + this.state.number;
        await existingUser(mobileNo).then((existingUserResponse) => {
            // console.log(existingUserResponse)
            if (existingUserResponse.status == "success") {
                this.setState({
                    name: existingUserResponse.data.name,
                    address: existingUserResponse.data.houseNo,
                    landmark: existingUserResponse.data.landmark
                })
            }
            else if (existingUserResponse.status == "failed") {

            }
        }).catch(() => {
            this.setState({
                message: 'An error occurred, contact data was not fetched ',
                snackopen: true
            })
        })
    }

    onSnackClose = () => {
        this.setState({
            snackopen: false
        })
    }
    keydown(e) {
        if (e.key === "Enter") {
            this.existingUserdata()
        }
    }
    async sendOrderToWhatsapp(message) {
        const mobileNumber = this.state.selectedCountry.countryPhoneCode + this.state.number
        await sendWhatsapp(mobileNumber, message, this.state.whatsInstanceid, this.state.whatsApptoken).then((response) => {
            // console.log(response)
        }).catch((error) => {
            this.setState({

                message: 'Whatsapp message was not delivered',
                snackopen: true,

            })
        })

    }

    action = (
        <>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => this.setState({
                    snackopen: false
                })}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );

    location(latitude, longitude) {
        this.setState({
            locationModal: (false),
            currentLatitude: (latitude),
            currentLongitude: (longitude),
        })
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column", flex: 1, background: '#f8fafc' }}>
                <HeaderCommon />

                {this.state.isLoading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.85)',
                        backdropFilter: 'blur(3px)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}>
                        <SpinnerLoader />
                        <p style={{ marginTop: 14, fontFamily: 'Poppins-Regular', fontSize: 14, color: '#1164af', fontWeight: 600 }}>Processing order...</p>
                    </div>
                )}

                <div className="share-catalogue-container">
                    <div className="share-catalogue-card">
                        <div className="share-form-grid">
                            <div className="share-form-col">
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                    <div>
                                        <p className="share-label">Code*</p>
                                        {
                                            this.state.selectedCountry.countryFlag == null ?
                                                <div
                                                    style={{ display: 'flex', border: '1px solid #d1d5db', alignItems: 'center', width: 75, height: 44, justifyContent: 'center', cursor: 'pointer', borderRadius: 8, background: '#f9fafb' }}
                                                    onClick={() => this.setState({ openCountryPicker: true })}
                                                >
                                                    <PhoneAndroidIcon style={{ fontSize: 20, color: '#555' }} />
                                                    <img src={Ionicon} height={8} alt="" style={{ marginLeft: 4 }} />
                                                </div>
                                                :
                                                <div
                                                    style={{ display: 'flex', border: '1px solid #d1d5db', alignItems: 'center', minWidth: 84, padding: '0 8px', height: 44, justifyContent: 'space-between', borderRadius: 8, cursor: 'pointer', backgroundColor: '#f9fafb' }}
                                                    onClick={() => this.setState({ openCountryPicker: true })}
                                                >
                                                    <img
                                                        src={this.state.selectedCountry.countryFlag}
                                                        width={22} height={15}
                                                        style={{ objectFit: 'cover', borderRadius: 2, border: '1px solid #ddd' }}
                                                        alt="flag"
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                    />
                                                    <span style={{ fontFamily: 'Poppins-Regular', margin: '0 4px', fontSize: 13, fontWeight: 600, color: '#1f2937' }}>
                                                        {this.state.selectedCountry.countryPhoneCode}
                                                    </span>
                                                    <img src={Ionicon} height={8} alt="" />
                                                </div>
                                        }
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <p className="share-label">Mobile Number*</p>
                                        <input
                                            type="number"
                                            className="share-input"
                                            placeholder="Enter mobile number"
                                            onChange={(event) => this.setState({ number: event.target.value })}
                                            value={this.state.number}
                                            onBlur={() => this.existingUserdata()}
                                            onKeyDown={(e) => this.keydown(e)}
                                        />
                                    </div>
                                </div>

                                <div className="ShareCatalogueField">
                                    <p className="share-label">Name*</p>
                                    <input
                                        className="share-input"
                                        placeholder="Enter your full name"
                                        value={this.state.name}
                                        onChange={(event) => this.setState({ name: event.target.value })}
                                    />
                                </div>

                                <div className="ShareCatalogueField">
                                    <p className="share-label">Landmark</p>
                                    <input
                                        className="share-input"
                                        placeholder="Near landmark (optional)"
                                        value={this.state.landmark}
                                        onChange={(event) => this.setState({ landmark: event.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="share-form-col">
                                <div className="ShareCatalogueField" style={{ marginTop: 0 }}>
                                    <p className="share-label">Address</p>
                                    <textarea
                                        className="share-textarea"
                                        placeholder="Enter your delivery address"
                                        value={this.state.address ? this.state.address : ''}
                                        onChange={(event) => this.setState({ address: event.target.value })}
                                        rows={3}
                                    />
                                </div>

                                <div className="ShareCatalogueField">
                                    <p className="share-label">Comments</p>
                                    <textarea
                                        className="share-textarea"
                                        placeholder="Order instructions or notes"
                                        value={this.state.comments}
                                        onChange={(event) => this.setState({ comments: event.target.value })}
                                        rows={2}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.cartTotalWithGst > 0 && (
                        <div style={{
                            width: '100%',
                            maxWidth: 400,
                            margin: '0 auto 14px auto',
                            background: '#ffffff',
                            border: '1px solid #e2e8f0',
                            borderRadius: 12,
                            padding: '12px 18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            boxSizing: 'border-box'
                        }}>
                            <div>
                                <span style={{ fontFamily: 'Poppins-Regular', fontSize: 14, fontWeight: 600, color: '#1e293b' }}>
                                    Total Amount
                                </span>
                                <span style={{ fontFamily: 'Poppins-Regular', fontSize: 11.5, color: '#16a34a', display: 'block', fontWeight: 500 }}>
                                    Includes 18% GST (+{this.state.currencySymbol || '₹'} {(this.state.cartBaseTotal * 0.18).toFixed(2)})
                                </span>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <span style={{ fontFamily: 'Roboto-medium', fontSize: 19, fontWeight: 700, color: '#e53935' }}>
                                    {this.state.currencySymbol || '₹'} {this.state.cartTotalWithGst.toFixed(2)}
                                </span>
                                <span style={{ fontFamily: 'Poppins-Regular', fontSize: 11, color: '#64748b', display: 'block' }}>
                                    Base: {this.state.currencySymbol || '₹'} {this.state.cartBaseTotal.toFixed(2)}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="share-actions-wrapper">
                        <button
                            type="button"
                            className='order-page-large-cancel-button'
                            style={{ flex: 1, maxWidth: 160 }}
                            onClick={() => this.props.navigation ? this.props.navigation('/Cart') : window.history.back()}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className='cart-page-large-order-button'
                            style={{ flex: 1.5, maxWidth: 220 }}
                            onClick={this.shareCatalogue}
                        >
                            Place Order
                        </button>
                    </div>
                </div>

                {
                    this.state.locationModal &&
                    <MapComponent
                        currentLatitude={this.state.currentLatitude}
                        currentLongitude={this.state.currentLongitude}
                        location={(latitude, longitude) => this.location(latitude, longitude)}
                    />
                }

                <Modal
                    open={this.state.openCountryPicker}
                    onClose={() => this.setState({ openCountryPicker: false, countrySearch: '' })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
                >
                    <div style={{
                        backgroundColor: 'white',
                        padding: '24px 20px',
                        width: '90%',
                        maxWidth: 440,
                        borderRadius: 16,
                        maxHeight: '80vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                        outline: 'none',
                        boxSizing: 'border-box'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                            <p style={{ fontSize: 18, fontFamily: 'Montserrat-SemiBold', margin: 0, color: '#212121' }}>
                                {language.countryChooseLabel}
                            </p>
                            <img
                                src={Closeicon}
                                alt="Close"
                                style={{ width: 22, height: 22, cursor: 'pointer', opacity: 0.7 }}
                                onClick={() => this.setState({ openCountryPicker: false, countrySearch: '' })}
                            />
                        </div>

                        {/* Search Bar */}
                        <div style={{ marginBottom: 12 }}>
                            <input
                                type="text"
                                placeholder="Search country or code..."
                                value={this.state.countrySearch || ''}
                                onChange={(e) => this.setState({ countrySearch: e.target.value })}
                                style={{
                                    width: '100%',
                                    padding: '9px 12px',
                                    borderRadius: 8,
                                    border: '1px solid #dcdcdc',
                                    fontSize: 14,
                                    outline: 'none',
                                    boxSizing: 'border-box',
                                    fontFamily: 'Poppins-Regular'
                                }}
                            />
                        </div>

                        {/* Country List */}
                        <div style={{ overflowY: 'auto', flex: 1, maxHeight: '55vh', paddingRight: 4 }}>
                            {(() => {
                                const list = Array.isArray(this.state.countriesList) && this.state.countriesList.length > 0
                                    ? this.state.countriesList
                                    : DEFAULT_COUNTRIES;
                                const filtered = list.filter(item => {
                                    if (!this.state.countrySearch) return true;
                                    const query = this.state.countrySearch.toLowerCase();
                                    return (item.countryName && item.countryName.toLowerCase().includes(query)) ||
                                           (item.countryPhoneCode && item.countryPhoneCode.includes(query)) ||
                                           (item.countryCode && item.countryCode.toLowerCase().includes(query));
                                });

                                if (filtered.length === 0) {
                                    return (
                                        <p style={{ textAlign: 'center', color: '#888', margin: '24px 0', fontSize: 14 }}>
                                            No countries found
                                        </p>
                                    );
                                }

                                return filtered.map((countrydata, i) => (
                                    this.renerderCounties(countrydata, i)
                                ));
                            })()}
                        </div>
                    </div>
                </Modal>
                <Modal
                    open={this.state.orderPlacedModal}
                    onClose={() => this.setState({ orderPlacedModal: false })}
                    aria-labelledby="modal-order-success"
                    aria-describedby="order-success-description"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        p: { xs: 1, sm: 2 },
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(15, 23, 42, 0.45)'
                    }}
                >
                    <div style={{ outline: 'none', width: '100%', display: 'flex', justifyContent: 'center', margin: 'auto' }}>
                        <OrderSucess
                            orderData={this.orderPlacedData}
                            encryptId={this.state.encryptedQr}
                            onClose={() => this.setState({ orderPlacedModal: false })}
                        />
                    </div>
                </Modal>
                <Modal
                    open={this.state.isCartComponentVisible}
                    transparent={false}
                >
                    <CartComponent invalidItems={this.state.invalidItems} continueOrder={() => this.ExistingUserCheck()} hideModal={() => this.setState({ isCartComponentVisible: false })} />
                </Modal>
                <Snackbar
                    open={this.state.snackopen}
                    autoHideDuration={10000}
                    onClose={this.onSnackClose}
                    message={this.state.message}
                    action={this.action}
                    ContentProps={{
                        style: { backgroundColor: '#388E3C' } // ✅ Green
                    }}
                />
            </div>
        )
    }
}

export default function (props) {
    const navigation = useNavigate()
    return <ShareCataloguePage {...props} navigation={navigation} />;
}